import { TextareaWYSIWYG } from './TextareaWYSIWYG';

export default TextareaWYSIWYG;